import type Geometry from 'ol/geom/Geometry'
import type Feature from 'ol/Feature'

type VehicleFeatureMetadata = {
  mode: 'on' | 'off' | 'label'
  type: 'vehicle'
  hasViolations: boolean
  ordersCount: number
  ordersWithViolationsCount: number
}

export const setVehicleFeatureMetadata = <Field extends keyof VehicleFeatureMetadata>(
  target: Feature<Geometry>,
  field: Field,
  value: VehicleFeatureMetadata[Field],
) => {
  target.set(field, value)
}

export const getVehicleFeatureMetadata = <Field extends keyof VehicleFeatureMetadata>(
  target: Feature<Geometry>,
  field: Field,
): VehicleFeatureMetadata[Field] | undefined => {
  return target.get(field)
}

export const removeVehicleFeatureMetadata = <Field extends keyof VehicleFeatureMetadata>(
  target: Feature<Geometry>,
  field: Field,
) => {
  target.unset(field)
}
